(function ( $ ) {
    $.fn.banana = function() {
        this.css( "color", "yellow !important" );
        this.append('<p>banana</p>')
        return this;
    };
}( $ ));
